import { EditOutlined } from '@ant-design/icons'
import { Button, Space, Tag, Typography } from 'antd'

import { ConfirmSwitch } from '@/components/common/ConfirmSwitch'

import { markupLabel, providerName } from '../format'
import type { GpuProvider } from '../hooks/useGpuAdmin'
import type { ProviderControls } from './useProviderControls'

interface Props {
  provider: GpuProvider
  // Absent for read-only operators: state renders as a tag.
  controls?: ProviderControls
}

export function salesTag(enabled: boolean) {
  return enabled ? (
    <Tag color="green">Selling</Tag>
  ) : (
    <Tag color="red">Sales off</Tag>
  )
}

export function spotTag(enabled: boolean) {
  return enabled ? <Tag color="green">Spot on</Tag> : <Tag>Spot off</Tag>
}

export function SalesCell({ provider, controls }: Props) {
  if (!controls) return salesTag(provider.sales_enabled)
  return (
    <ConfirmSwitch
      checked={provider.sales_enabled}
      target={`sales of ${providerName(provider.key)}`}
      onLabel="Enable"
      offLabel="Disable"
      onConfirm={(next) => controls.onToggleSales(provider, next)}
    />
  )
}

export function SpotCell({ provider, controls }: Props) {
  if (!provider.capabilities.spot) {
    return (
      <Typography.Text type="secondary" style={{ whiteSpace: 'nowrap' }}>
        No spot
      </Typography.Text>
    )
  }
  if (!controls) return spotTag(provider.spot_sales_enabled)
  return (
    <ConfirmSwitch
      checked={provider.spot_sales_enabled}
      target={`spot sales of ${providerName(provider.key)}`}
      onLabel="Enable"
      offLabel="Disable"
      onConfirm={(next) => controls.onToggleSpot(provider, next)}
    />
  )
}

export function MarkupCell({ provider, controls }: Props) {
  return (
    <Space size={4}>
      {markupLabel(provider)}
      {controls && (
        <Button
          size="small"
          type="text"
          icon={<EditOutlined />}
          aria-label={`Change markup of ${providerName(provider.key)}`}
          onClick={(e) => {
            e.stopPropagation()
            controls.onEditMarkup(provider)
          }}
        />
      )}
    </Space>
  )
}
